<template>
  <div>
    <div class="dropdown">
      <q-btn-dropdown class="col  q-mt-lg" :label="product_name">
        <q-list>
          <q-item clickable v-for="item in product_select" :key="item" v-close-popup @click="getProductName(item)">
            <q-item-section>
              <q-item-label>{{ item }}</q-item-label>
            </q-item-section>
          </q-item>
        </q-list>
      </q-btn-dropdown>
    </div>

    <div class="row q-mt-sm">
      <div class="example col">
        <div class="left-pad q-mt-md">
          <h5>Comparison of MRP and Price of diferent competitors</h5>
        </div>
        <apexchart class="left-pad" width="500" height="350" type="bar" :options="chartOptions2" :series="series2">
        </apexchart>

      </div>
      <div class="example col q-ml-md">
        <div class="left-pad q-mt-md">
          <h5>Total review count</h5>
        </div>
        <apexchart class="left-pad q-mt-xl q-ml-xl" ref="donut" width="500" type="donut" :options="chartOptions3"
          :series="series3">
        </apexchart>
      </div>
    </div>
    <div class="row q-mt-md q-mb-md">

      <div class="example col">
        <div class=" q-mt-md">
          <h5 class="left-pad1">Comparison of recent positive and negative reviews of competitors</h5>
        </div>
        <apexchart class="left-pad" width="500" type="bar" :options="chartOptions1" :series="series1"></apexchart>

      </div>
      <div class="example col q-ml-md">
        <div class="left-pad q-mt-md">
          <h5>Perceptual Mapping: Review Quality vs Price of the Product </h5>
        </div>
        <div class="left-pad3 q-mt-sm">
          <p class="subtitle">The size of the bubble depends on the total review</p>
        </div>
        <apexchart class="left-pad q-mt-xl" width="500" height="375" type="bubble" :options="chartOptions"
          :series="series">
        </apexchart>
      </div>
    </div>


  </div>
</template>
<script>
export default {
  name: 'BubbleExample',
  name: 'BarExample',
  name: 'DonutExample',
  data: function () {
    return {
      api_url: this.$store.state.API_URL[process.env.VUE_APP_ENV],
      product_name: 'select Product',
      product_select: [],
      price_of_product: [],
      review_count: [],
      review_quality: [],
      data_temp: [],
      dataset: [],
      positive_reviews: [],
      negative_review: [],
      brand_name: [],
      MRP_of_Product: [],
      showGraph: false,
      chartOptions: {
        plotOptions: {
          bubble: {
            zScaling: true,
            minBubbleRadius: 5,
            maxBubbleRadius: 55,
          }
        },
        dataLabels: {
          enabled: false
        },
        fill: {
          opacity: 1,
          gradient: {
            enabled: false
          }
        },
        xaxis: {
          tickAmount: 12,
          type: 'category',
        },
        yaxis: {
          max: 1000
        }
      },
      series: [],
      chartOptions1: {
        chart: {
          type: 'bar',
          height: 430
        },
        colors: ['#008000', '#FF0000'],
        plotOptions: {
          bar: {
            vertical: true,
            dataLabels: {
              position: 'top',
            },
          }
        },
        dataLabels: {
          enabled: true,
          offsetX: -6,
          style: {
            fontSize: '12px',
            colors: ['#fff']
          }
        },
        stroke: {
          show: true,
          width: 1,
          colors: ['#fff']
        },
        tooltip: {
          shared: true,
          intersect: false
        },
        xaxis: {
          labels: {
            hideOverlappingLabels: false,
            trim: true,
          }
        },
      },
      series1: [{
        name: 'Positive reviews',
      }, {
        name: 'Negative reviews',
      }],
      chartOptions2: {
        chart: {
          type: 'bar',
          height: 430
        },
        colors: ['#87CEEB', '#0000FF'],
        plotOptions: {
          bar: {
            vertical: true,
            dataLabels: {
              position: 'top',
            },
          }
        },
        dataLabels: {
          enabled: true,
          offsetX: -6,
          style: {
            fontSize: '12px',
            colors: ['#fff']
          }
        },
        stroke: {
          show: true,
          width: 1,
          colors: ['#fff']
        },
        tooltip: {
          shared: true,
          intersect: false
        },
        xaxis: {
          labels: {
            hideOverlappingLabels: false,
            trim: true,
          }
        },
      },
      series2: [{
        name: 'MRP of Product',
      }, {
        name: 'Price of Product',
      }],
      chartOptions3: {
        legend:
        {
          position: 'bottom'
        },
      },
      series3: [],
    }
  },
  mounted() {
    this.$q.loading.show({
      message: "Authenticating please wait..",
    });
    if (this.$cookies.isKey("login_authentication")) {
      let encryptedText = this.$cookies.get("login_authentication");
      const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);
      if (decryptedText == "authenticated") {
        this.$store.dispatch("setPathName", "/pricewatch/dashboard");
        this.$q.loading.hide();
        this.isAuthenticated = true;
      }
      else {
        this.$q.loading.hide();
        this.$router.push({
          name: "NotAuthenticated",
        });
        return;
      }
    }
    else if (this.$cookies.isKey("login_authentication1")) {
      let encryptedText = this.$cookies.get("login_authentication1");
      const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);
      if (decryptedText == "authenticated") {
        this.$store.dispatch("setPathName", "/pricewatch/dashboard");
        this.$q.loading.hide();
        this.isAuthenticated = true;
      }
      else {
        this.$q.loading.hide();
        this.$router.push({
          name: "NotAuthenticated",
        });
        return;
      }
    }
    else if (this.$cookies.isKey("login_authentication2")) {
      let encryptedText = this.$cookies.get("login_authentication2");
      const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);
      if (decryptedText == "authenticated") {
        this.$store.dispatch("setPathName", "/pricewatch/dashboard");
        this.$q.loading.hide();
        this.isAuthenticated = true;
      }
      else {
        this.$q.loading.hide();
        this.$router.push({
          name: "NotAuthenticated",
        });
        return;
      }
    }
    else {
      this.$q.loading.hide();
      this.$router.push({
        name: "NotAuthenticated",
      });
      return;
    }
    var productsURL = this.api_url + "/dashboard/get_data/main/" + this.$org_id.label;
    this.$http
      .get(productsURL)
      .then((response) => {
        let result = response.data;
        this.data_temp = result;
        let data1 = result.map((item) =>
          item.user_product
        );
        this.product_select = [...new Set(data1)];;
      })
  },
  methods: {
    getProductName(details) {
      this.product_name = details;
      this.showGraph = true;
      let products = this.data_temp.filter((items) => {
        return items.user_product == this.product_name;
      })
      this.dataset = products;
      let data2 = this.dataset.map((item) =>
        item.Positive_review
      );
      this.positive_reviews = Object.values(data2);
      let data3 = this.dataset.map((item) =>
        item.brand_name
      );
      let data4 = this.dataset.map((item) =>
        item.Negative_review
      );
      let data8 = this.dataset.map((item) =>
        item.Price_of_Product
      );
      let data9 = this.dataset.map((item) =>
        item.Review_count
      );
      let data10 = this.dataset.map((item) =>
        item.Review_quality
      );
      this.negative_review = Object.values(data4);
      this.brand_name = Object.values(data3);
      this.price_of_product = Object.values(data8);
      this.review_count = Object.values(data9);
      this.review_quality = Object.values(data10);
      let max_product_price = 0;
      this.series = [];
      for (var i = 0; i < this.price_of_product.length; i++) {
        if (max_product_price < this.price_of_product[i]) {
          max_product_price = this.price_of_product[i];
        }
        let temp_arr = [this.price_of_product[i], this.review_quality[i], this.review_count[i]];
        let json_obj = {
          name: this.brand_name[i],
          data: [temp_arr]
        }
        this.series.push(json_obj);
      }
      let division = 0;
      if (max_product_price <= 1500) {
        division = 100;
      }
      else if (max_product_price <= 4000) {
        division = 200;
      }
      else if (max_product_price <= 7000) {
        division = 500;
      }
      else if (max_product_price <= 12000) {
        division = 1000;
      }
      else {
        1500
      }
      if ((max_product_price + 2 * division - max_product_price % division) / division <= 13) {
        this.chartOptions = {
          dataLabels: {
            enabled: false
          },
          fill: {
            opacity: 0.8,
            gradient: {
              enabled: false
            }
          },
          xaxis: {
            tickAmount: (max_product_price + 2 * division - max_product_price % division) / division,
            type: 'numeric',
            title: {
              text: 'Price of the Product',
              offsetX: 0,
              offsetY: 80,
              style: {
                color: '#000',
                fontSize: '14px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 600,
                cssClass: 'apexcharts-xaxis-title',
              },
            },
            // min: 0,
            // max: max_product_price + 100
            min: 0,
            max: max_product_price + 2 * division - max_product_price % division,
          },
          yaxis: {
            tickAmount: 5,
            max: 5,
            title: {
              text: "Review Quality",
              style: {
                color: '#000',
                fontSize: '14px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 600,
                cssClass: 'apexcharts-xaxis-title',
              }
            },
          }
        }
      }
      else {
        this.chartOptions = {
          dataLabels: {
            enabled: false
          },
          fill: {
            opacity: 0.8,
            gradient: {
              enabled: false
            }
          },
          xaxis: {
            tickAmount: (max_product_price + 2 * division - max_product_price % division) / division,
            type: 'numeric',
            title: {
              text: 'Price of the Product',
              offsetX: 0,
              offsetY: 130,
              style: {
                color: '#000',
                fontSize: '14px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 600,
                cssClass: 'apexcharts-xaxis-title',
              },
            },
            // min: 0,
            // max: max_product_price + 100
            min: 0,
            max: max_product_price + 2 * division - max_product_price % division,
          },
          yaxis: {
            tickAmount: 5,
            max: 5,
            title: {
              text: "Review Quality",
              style: {
                color: '#000',
                fontSize: '14px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 600,
                cssClass: 'apexcharts-xaxis-title',
              }
            },
          }
        }
      }
      this.chartOptions1.xaxis.categories = this.brand_name
      this.series1 = [{
        data: this.positive_reviews
      }, {
        data: this.negative_review
      }]
      this.chartOptions1 = {
        chart: {
          type: 'bar',
          height: 430
        },
        colors: ['#008000', '#FF0000'],
        plotOptions: {
          bar: {
            vertical: true,
            dataLabels: {
              position: 'top',
            },
          }
        },
        dataLabels: {
          enabled: true,
          offsetX: -6,
          style: {
            fontSize: '12px',
            colors: ['#fff']
          }
        },
        stroke: {
          show: true,
          width: 1,
          colors: ['#fff']
        },
        tooltip: {
          shared: true,
          intersect: false
        },
        xaxis: {
          categories: this.brand_name,
          hideOverlappingLabels: true
        },
      }
      let data5 = this.dataset.map((item) =>
        item.MRP_of_Product
      );
      this.MRP_of_Product = Object.values(data5);
      let data6 = this.dataset.map((item) =>
        item.Price_of_Product
      );
      this.Price_of_Product = Object.values(data6);
      this.chartOptions2 = {
        chart: {
          type: 'bar',
          height: 430
        },
        plotOptions: {
          bar: {
            vertical: true,
            dataLabels: {
              position: 'top',
            },
          }
        },
        dataLabels: {
          enabled: true,
          offsetX: -6,
          style: {
            fontSize: '12px',
            colors: ['#fff']
          }
        },
        stroke: {
          show: true,
          width: 1,
          colors: ['#fff']
        },
        tooltip: {
          shared: true,
          intersect: false
        },
        xaxis: {
          categories: this.brand_name,
          hideOverlappingLabels: true
        },
      }
      this.series2 = [{
        data: this.MRP_of_Product
      }, {
        data: this.Price_of_Product
      }]
      let data7 = this.dataset.map((item) =>
        item.Review_count
      );
      this.Review_count = Object.values(data7);
      this.chartOptions3 = {
        labels: this.brand_name,
      }
      this.series3 = this.Review_count
    }
  }
}
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@500&display=swap");

body {
  font-family: "Montserrat", sans-serif !important;
}

.apexcharts-menu-icon,
.apexcharts-selection-icon {
  display: none;
}

.example {
  box-shadow: 0px 3px 6px #9BDDD3;
  border-radius: 15px;
  background-color: white;
}

.left-pad {
  margin-left: 30px;
  color: #102689;
  font-weight: bold;
  text-align: center;
  font-weight: bold;
}

.left-pad1 {
  color: #102689;
  font-weight: 600;
  text-align: center;
}

.left-pad h5 {
  color: #102689;
  font-weight: 600;
  text-align: center;
}

.subtitle {
  font-size: 16px;
  text-align: center;
  color: #4682B4;
}

.apexcharts-toolbar {
  display: none !important;
}

.dropdown {
  margin-left: 970px;
  margin-bottom: 20px;
  color: black;
  font-size: 15px;
}
</style>